var app_tv_ranker_table = $('#app-tv-comscore-add-ranker-report-table');

if (app_tv_ranker_table.length) {
    var saved_table_data = [];
    var unsaved_table_data = [];

    var saved_table;
    var unsaved_table;

    $(document).ready(function(){

        tvReportTables();

    });

    var tvReportTables = function(){
        saved_table_data = [];
        unsaved_table_data = [];
        $.ajax({
            type: "GET",
            url: '/ratings/tv/comscore/additional/ranker/station/list/saved',
            dataType: 'json',
            success: function (data) {
                $.each(data['data'], function(index, value){
                    push = {
                        'order': value['order'],
                        'name': value['name'],
                        'slug': value['slug'],
                        'created_at': value['human_created_at']
                    };

                    saved_table_data.push(push);
                });

                if (saved_table instanceof $.fn.dataTable.Api) {
                    var table = $('#app-tv-ranker-report-saved').DataTable();

                    table.clear();
                    table.rows.add(saved_table_data);
                    table.draw();
                } else {
                    saved_table = $('#app-tv-ranker-report-saved').DataTable({
                        data: saved_table_data,
                        columns: [
                            {data:'order'},
                            {data: 'name'},
                            {data: 'created_at'},
                            {data: 'slug'}
                        ],
                        order: [ 0, "asc" ],
                        destroy: true,
                        pageLength: user_entries,
                        "columnDefs": [
                            {
                                "targets": 0,
                                "visible": false,
                                "searchable": false,
                            },
                            {
                            "targets": 3,
                            "orderable": false,
                            "createdCell": function (td, cellData, rowData, row, col) {
                                console.log('-----');
                                console.log(cellData);
                                var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                                    '<a href="/ratings/tv/comscore/additional/ranker/station/view/' +
                                    cellData +
                                    '" role="button" class="btn btn-info btn-sm">' +
                                    '<i class="fa fa-eye"></i> View' +
                                    '</a>' +
                                    '<a href="/ratings/tv/comscore/additional/ranker/station/edit/' + cellData +' "  class="btn btn-success btn-sm btn-disabled edit-report " role="button">' +
                                    '<i class="fa fa-pencil"></i> Edit' +
                                    '</a>' +
                                    '</div>' +
                                    '<a href="javascript:void(0)" class="btn btn-danger btn-sm btn-disabled delete-report" data-slug="' + cellData + '" role="button">' +
                                    '<i class="fa fa-trash-o"></i> Delete' +
                                    '</a></div>';
                                $(td).html(html);
                            }
                        }],
                        "drawCallback": function( settings ) {
                            $('.delete-report').unbind('click').bind('click', function(){
                                deleteTVReport($(this).attr('data-slug'));
                            });
                        }
                    });
                }

            }
        });

        $.ajax({
            type: "GET",
            url: '/ratings/tv/comscore/additional/ranker/station/list/temp',
            dataType: 'json',
            success: function (data) {
                $.each(data['data'], function(index, value){
                    push = {
                        'order': value['order'],
                        'name': value['name'],
                        'slug': value['slug'],
                        'created_at': value['human_created_at']
                    };

                    unsaved_table_data.push(push);
                });

                if (unsaved_table instanceof $.fn.dataTable.Api) {
                    var table = $('#app-tv-ranker-report-temp').DataTable();

                    table.clear();
                    table.rows.add(unsaved_table_data);
                    table.draw();
                } else {
                    unsaved_table = $('#app-tv-ranker-report-temp').DataTable({
                        data: unsaved_table_data,
                        columns: [
                            {data:'order'},
                            {data: 'name'},
                            {data: 'created_at'},
                            {data: 'slug'}
                        ],
                        order: [ 0, "asc" ],
                        destroy: true,
                        pageLength: user_entries,
                        "columnDefs": [
                            {
                                "targets": 0,
                                "visible": false,
                                "searchable": false,
                            },
                            {
                            "targets": 3,
                            "orderable": false,
                            "createdCell": function (td, cellData, rowData, row, col) {
                                var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                                    '<a href="/ratings/tv/comscore/additional/ranker/station/view/' +
                                    cellData +
                                    '" role="button" class="btn btn-info btn-sm">' +
                                    '<i class="fa fa-eye"></i> View' +
                                    '</a>' +
                                    '</div>' +
                                    '<a href="javascript:void(0)" class="btn btn-danger btn-sm btn-disabled delete-report" data-slug="' + cellData + '" role="button">' +
                                    '<i class="fa fa-trash-o"></i> Delete' +
                                    '</a></div>';
                                $(td).html(html);
                            }
                        }],
                        "drawCallback": function( settings ) {
                            $('.delete-report').unbind('click').bind('click', function(){
                                deleteTVReport($(this).attr('data-slug'));
                            });
                        }
                    });
                }
            }
        });
    };


    var deleteTVReport = function(slug) {
        var urlVar = '/ratings/tv/comscore/additional/ranker/station/delete/' + slug;
        swal({
                title: "Warning",
                text: "Are you sure you want to delete?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader();
                    $.ajax({
                        url: urlVar,
                        success: function (response) {
                            global_notification('success', 'Report deleted.');
                            tvReportTables();
                            hide_loader();
                        },
                        error: function (xhr) {
                            ajax_error();
                            debug(xhr.responseText);
                            tvReportTables();
                        }
                    });
                }
            });
    }
};
